var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 0C19.0276 0 0 19.0276 0 42.5C0 65.9724 19.0276 85 42.5 85C65.9724 85 85 65.9724 85 42.5C85 19.0276 65.9724 0 42.5 0ZM42.5 77.0312C23.4582 77.0312 7.96875 61.54 7.96875 42.5C7.96875 23.46 23.4582 7.96875 42.5 7.96875C61.5418 7.96875 77.0312 23.4582 77.0312 42.5C77.0312 61.5418 61.54 77.0312 42.5 77.0312Z",
    fill: "#FFAB2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6941 43.8794H39.1142V52.1687H44.6941C45.8203 52.1687 46.8651 51.7118 47.5982 50.9451C48.365 50.2102 48.8219 49.1671 48.8219 48.0072C48.8237 45.7388 46.9625 43.8794 44.6941 43.8794Z",
    fill: "#FFAB2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 11.5104C25.4115 11.5104 11.5104 25.4114 11.5104 42.4999C11.5104 59.5885 25.4115 73.4895 42.5 73.4895C59.5885 73.4895 73.4896 59.5867 73.4896 42.4999C73.4896 25.4132 59.5868 11.5104 42.5 11.5104ZM48.8059 56.8508H45.1509V62.5954H41.3171V56.8508H39.2116V62.5954H35.36V56.8508H28.5883V53.2454H32.3248V31.6412H28.5883V28.0358H35.36V22.4063H39.2116V28.0358H41.3171V22.4063H45.1509V28.0358H48.4801C50.3395 28.0358 52.0536 28.8026 53.2773 30.0262C54.5009 31.2498 55.2677 32.964 55.2677 34.8234C55.2677 38.4624 52.3954 41.4321 48.8059 41.5951C53.0152 41.5951 56.4099 45.0216 56.4099 49.2309C56.4099 53.4242 53.017 56.8508 48.8059 56.8508Z",
    fill: "#FFAB2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1591 38.7883C47.8285 38.1189 48.2357 37.2211 48.2357 36.21C48.2357 34.2036 46.6048 32.5709 44.5967 32.5709H39.1142V39.865H44.5967C45.5919 39.865 46.5056 39.44 47.1591 38.7883Z",
    fill: "#FFAB2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc1);
export default __webpack_public_path__ + "static/media/btc1.54993ad99827c5cd38192f886d52cd4e.svg";
export { ForwardRef as ReactComponent };